// extracted by mini-css-extract-plugin
export var circle = "_36-2";
export var icon = "_36-a";
export var iconHighlight = "_36-0";
export var lg = "_36-8";
export var md = "_36-7";
export var outline = "_36-4";
export var sm = "_36-6";
export var square = "_36-1";
export var xl = "_36-9";
export var xs = "_36-5";
export var xxs = "_36-3";